import { useEffect, type ReactNode } from 'react'

import { useReportsEnabled } from 'app/dataProviders/reports/hooks'

type Props = {
  children: ReactNode
  report: string
  fallback?: ReactNode
  onReportDisabled?: () => void
}

const IsReportEnabled = ({ children, report, fallback, onReportDisabled }: Props) => {
  const { reportsEnabled, loading } = useReportsEnabled()
  const enabled = reportsEnabled.includes(report)

  useEffect(() => {
    if (onReportDisabled && !loading && !enabled) {
      onReportDisabled()
    }
  }, [loading, enabled]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading && fallback) {
    return fallback
  }

  if (loading || !enabled) {
    return null
  }

  return children
}

export default IsReportEnabled
